import moment, {Moment} from 'moment';
import sortedLastIndex from 'lodash/sortedLastIndex';

import {formatDate} from 'common/util/date';
import {TimeUnit} from 'common/widgets/date-range-picker/models/types';
import {Timezone} from 'common/constants';
import {offsetForHighcharts} from 'common/util/date';

import {Annotation} from './types';

export const ANNOTATION_GROUP_DATE_CUSTOM_FORMATTING = {[TimeUnit.Day]: `ddd, MMM D`};

export function parseAnnotationDate(isoDate: string): Moment {
  // retain the timezone info in the iso date (for later formatting, etc...)
  // assume your browser is in PDT
  // moment(`2025-08-01T12:00:00-05:00`).format() -> 2025-08-01T10:00:00-07:00
  // moment.parseZone(`2025-08-01T12:00:00-05:00`).format() -> 2025-08-01T12:00:00-05:00
  return moment.parseZone(isoDate, moment.ISO_8601);
}

export function formatAnnotationDateForGroup(
  isoDate: string,
  {timezone, timeUnit}: {timezone: Timezone; timeUnit?: TimeUnit},
) {
  timeUnit = timeUnit ?? TimeUnit.Day;
  return formatDate(parseAnnotationDate(isoDate), {
    unit: timeUnit,
    displayRangeIfWeek: true,
    customFormatting: ANNOTATION_GROUP_DATE_CUSTOM_FORMATTING,
    timezone,
    hideTimezone: true,
  });
}

export function formatAnnotationDate(isoDate: string, {timezone, timeUnit}: {timezone: Timezone; timeUnit?: TimeUnit}) {
  const dateMoment = parseAnnotationDate(isoDate);
  return formatDate(dateMoment, {
    unit: timeUnit,
    customFormatting: {[timeUnit as string]: `MMM Do, YYYY h:mma`},
    timezone,
    hideTimezone: true,
  });
}

export function groupAnnotations(
  utcOffset: number,
  timezone: string,
  annotations: Annotation[],
  ticks: string[],
): Map<number, Annotation[]> {
  const allAnnotations = new Map();

  annotations.forEach((annotation) => {
    annotation.highchartsDate = offsetForHighcharts(moment(annotation.date), timezone, utcOffset);

    const annotationDateMS = moment.utc(annotation.highchartsDate).valueOf();
    const index = parseInt(ticks[sortedLastIndex(ticks, annotationDateMS.toString()) - 1]);

    if (allAnnotations.has(index)) {
      const annotationsAtTime = allAnnotations.get(index);
      annotationsAtTime.push(annotation);
      allAnnotations.set(index, annotationsAtTime);
    } else {
      allAnnotations.set(index, [annotation]);
    }
  });
  return allAnnotations;
}
